<template>
  <div class="animate-pulse">
    <!-- Booking Card Skeleton -->
    <div v-if="type === 'booking-card'" class="bg-white shadow-sm rounded-lg p-4 space-y-3">
      <div class="flex items-center space-x-3">
        <div class="w-12 h-12 bg-gray-300 rounded-lg"></div>
        <div class="flex-1 space-y-2">
          <div class="h-4 bg-gray-300 rounded-sm w-3/4"></div>
          <div class="h-3 bg-gray-300 rounded-sm w-1/2"></div>
        </div>
        <div class="h-4 bg-gray-300 rounded-sm w-16"></div>
      </div>
      <div class="flex justify-between items-center">
        <div class="h-3 bg-gray-300 rounded-sm w-20"></div>
        <div class="h-3 bg-gray-300 rounded-sm w-16"></div>
      </div>
      <div class="flex justify-between">
        <div class="h-4 bg-gray-300 rounded-sm w-24"></div>
        <div class="h-4 bg-gray-300 rounded-sm w-20"></div>
      </div>
    </div>

    <!-- Booking Details Skeleton -->
    <div v-else-if="type === 'booking-details'" class="bg-white shadow-sm rounded-lg p-6 space-y-6">
      <div class="space-y-4">
        <div class="h-6 bg-gray-300 rounded-sm w-1/3"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div v-for="i in 6" :key="i" class="space-y-2">
            <div class="h-4 bg-gray-300 rounded-sm w-20"></div>
            <div class="h-5 bg-gray-300 rounded-sm w-32"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Calendar Skeleton -->
    <div v-else-if="type === 'calendar'" class="space-y-4">
      <div class="h-8 bg-gray-300 rounded-sm w-48 mx-auto"></div>
      <div class="grid grid-cols-7 gap-2">
        <div v-for="i in 35" :key="i" class="h-10 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="space-y-2">
        <div v-for="i in 4" :key="i" class="h-12 bg-gray-300 rounded-sm"></div>
      </div>
    </div>

    <!-- Admin Table Skeleton -->
    <div v-else-if="type === 'admin-table'" class="bg-white shadow-sm rounded-lg overflow-hidden">
      <div class="px-6 py-4 border-b">
        <div class="h-6 bg-gray-300 rounded-sm w-1/4"></div>
      </div>
      <div class="divide-y divide-gray-200">
        <div v-for="i in 5" :key="i" class="px-6 py-4 flex items-center space-x-4">
          <div class="h-4 bg-gray-300 rounded-sm w-20"></div>
          <div class="h-4 bg-gray-300 rounded-sm w-32"></div>
          <div class="h-4 bg-gray-300 rounded-sm w-24"></div>
          <div class="h-4 bg-gray-300 rounded-sm w-16"></div>
          <div class="h-4 bg-gray-300 rounded-sm w-20"></div>
          <div class="h-4 bg-gray-300 rounded-sm w-16"></div>
        </div>
      </div>
    </div>

    <!-- Pricing Options Skeleton -->
    <div v-else-if="type === 'pricing-options'" class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div v-for="i in 3" :key="i" class="bg-white border-2 border-gray-200 rounded-lg p-6 space-y-4">
        <div class="h-8 bg-gray-300 rounded-sm w-16 mx-auto"></div>
        <div class="h-6 bg-gray-300 rounded-sm w-20 mx-auto"></div>
        <div class="h-4 bg-gray-300 rounded-sm w-full"></div>
        <div class="h-4 bg-gray-300 rounded-sm w-3/4 mx-auto"></div>
      </div>
    </div>

    <!-- Generic Content Skeleton -->
    <div v-else class="space-y-3">
      <div class="h-4 bg-gray-300 rounded-sm"></div>
      <div class="h-4 bg-gray-300 rounded-sm w-5/6"></div>
      <div class="h-4 bg-gray-300 rounded-sm w-4/6"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type?: 'booking-card' | 'booking-details' | 'calendar' | 'admin-table' | 'pricing-options' | 'generic'
}

withDefaults(defineProps<Props>(), {
  type: 'generic'
})
</script>

<style scoped>
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>